<!--
 * @Author: Tina Huang
 * @Date: 2023-06-27 16:33:29
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-01-23 10:45:32
 * @Description: 
-->
<template>
  <div :class="['lib-container', titleFixed ? 'hasfix' : '']">
    <div>
      <div :class="['selector', titleFixed ? 'fixed' : '']">
        <router-link :to="{ name: 'mpro' }">
          <el-button
            type="warning"
            size="small"
            data-splitbee-event="Be VIP in mobile"
            >成为会员领取所有模版</el-button
          >
        </router-link>
      </div>
      <div class="template-list">
        <div
          class="item"
          :class="item.direction"
          v-for="item in list"
          :key="item.title"
          @click="handleTempClick(item)"
        >
          <div class="fix">
            <el-tag v-if="item.code" effect="dark" type="warning" size="small"
              >限定分享</el-tag
            >
          </div>
          <el-image class="cover" :src="item.cover" lazy></el-image>
          <div class="info">
            <h3>
              {{ item.title }}
              <el-tag
                v-if="!item.forward && item.pay && item.direction === 'row'"
                effect="dark"
                type="danger"
                size="small"
                >{{ item.pay ? `¥ ${item.pay}` : "" }}</el-tag
              >
            </h3>
            <p>{{ item.description }}</p>
          </div>
          <template v-if="item.forward">
            <el-button
              class="copy-btn"
              type="success"
              plain
              round
              icon="el-icon-top-right"
              @click.stop="handleCopy(item)"
              >{{ "Coming soon" }}</el-button
            >
          </template>
          <template v-else-if="item.pay">
            <el-tag
              v-if="item.pay && item.direction === 'col'"
              effect="dark"
              type="danger"
              size="small"
              class="col-price"
              >{{ item.pay ? `¥ ${item.pay}` : "" }}</el-tag
            >
            <el-button
              class="copy-btn"
              type="warning"
              plain
              round
              icon="el-icon-top-right"
              @click="handleCopy(item)"
              >{{ "去购买" }}</el-button
            >
          </template>
          <template v-else-if="item.lock">
            <el-button
              class="copy-btn"
              type="primary"
              plain
              round
              icon="el-icon-lock"
              :disabled="true"
              >{{ "已锁定" }}</el-button
            >
          </template>
          <template v-else-if="!isLogin">
            <el-button
              class="copy-btn"
              type="primary"
              plain
              round
              icon="el-icon-top-right"
              @click.stop="handleNologinCopy(item)"
              >{{ "去拷贝" }}</el-button
            >
          </template>
          <template v-else-if="item.link.includes('http')">
            <a
              :href="item.link"
              target="_blank"
              data-splitbee-event="Duplicate template in mobile"
            >
              <el-button
                class="copy-btn"
                type="primary"
                plain
                round
                icon="el-icon-top-right"
                >{{ "去拷贝" }}</el-button
              >
            </a>
          </template>
          <router-link
            v-else
            :to="{ name: 'mpicks_get', params: { type: 'code' } }"
            target="_blank"
            data-splitbee-event="Duplicate template in mobile with code"
          >
            <el-button
              class="copy-btn"
              type="primary"
              plain
              round
              icon="el-icon-top-right"
              @click.stop
              >{{ "去拷贝" }}</el-button
            >
          </router-link>
        </div>
      </div>
    </div>
    <!-- outflow -->

    <el-dialog
      title="请截图使用手淘扫码查看"
      :visible.sync="dialogVisible"
      width="80%"
    >
      <el-image
        style="width: 200px; height: 200px; display: block; margin: 0 auto"
        :src="currentProduct && currentProduct.pay_img"
        fit="contain"
      ></el-image>
      <p style="text-align: center">或者请在其他手机浏览器内使用组件库</p>
    </el-dialog>
  </div>
</template>
<script>
import tool from "../../lib/index.js";
export default {
  data() {
    return {
      list: [],
      freeList: [],
      payList: [],
      active_tab: 0,
      isLogin: tool.isLogin(this.$token),
      tempType: "all",
      titleFixed: false,
      dialogVisible: false,
      currentProduct: null,
    };
  },
  mounted() {
    this.getDatas();
    window.addEventListener("scroll", this.calcScroll);
  },
  methods: {
    getDatas() {
      const _this = this;
      this.$axios.get(`./picks.json?v=${Math.random()}`).then((res) => {
        let list = res.data.filter((x) => !x.hide);
        let freeList = list.filter((x) => !x.pay && !x.forward);
        let payList = list.filter((x) => x.pay && !x.forward);
        _this.list = list;
        _this.freeList = freeList;
        _this.payList = payList;
      });
    },
    handleTempClick(item) {
      if (item.forward)
        return this.$message({
          message: "模版建设中，敬请期待",
          type: "success",
        });
      if (item.pay) return this.handleCopy(item);
      else if (!this.isLogin) return this.handleNologinCopy(item);
      else if (item.link.includes("http")) {
        window.open(item.link, "_blank");
      } else {
        this.$router.push({ name: "mpicks_get", params: { type: "code" } });
      }
    },
    // toShowVideo(item) {},
    // 购买模版
    handleCopy(item) {
      splitbee &&
        splitbee.track("Buy template in mobile", {
          title: item.title,
        });
      if (item.forward)
        return this.$message({
          message: "模版建设中，敬请期待",
          type: "success",
        });
      if (tool.isWechat()) {
        this.currentProduct = item;
        this.dialogVisible = true;
      } else {
        window.open(item.m_pay_link);
      }
    },
    handleNologinCopy(item) {
      const _this = this;
      this.$message({
        message: "输入口令拷贝模版",
        type: "warning",
      });
      splitbee.track("Copy template without logining in mobile", {
        title: item.title,
      });
      this.$code({
        successGo() {
          console.log("login success");
          _this.isLogin = true;
        },
      });
    },
    calcScroll() {
      let self = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let offsetTop = document.getElementById("site-header").offsetHeight;
      self.titleFixed = scrollTop > offsetTop;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../less/var.less";
.lib-container {
  padding: 5vw;
  min-height: 70vh;
  position: relative;
  background: #ffffff;
  h2 {
    font-size: 0.6rem;
    text-align: center;
  }
  &.hasfix {
    padding-top: 85.5px;
  }
}
.selector {
  background-color: #ffffff;
  &.fixed {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    z-index: 2;
    padding: 20px 0;
  }
}
.template-list {
  padding-top: 30px;
  //   display: flex;
  //   flex-wrap: wrap;
  //   flex-direction: column;
  // justify-content: space-between;
  //   margin-left: -2vw;
  .item {
    display: flex;
    width: 330px;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 10%);
    position: relative;
    margin: 0 auto 20px;
    cursor: pointer;
    .fix {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }
    h3 {
      font-size: 0.4rem;
      margin: 0.3rem 0;
      display: flex;
      align-items: center;
      .el-tag {
        margin-left: 5px;
      }
    }
    p {
      font-size: 0.28rem;
      margin: 0.3rem 0;
    }
    .copy-btn {
      position: absolute;
      right: 0.2rem;
      bottom: 0.2rem;
    }
    &.col {
      .cover {
        width: 165px;
        height: 200px;
        display: inline-block;
      }
      .info {
        width: 165px;
        height: 100%;
        box-sizing: border-box;
        padding: 0.2rem;
      }
    }
    &.row {
      flex-direction: column;
      .cover {
        width: 330px;
        height: 200px;
        display: block;
        margin: 0 auto;
        object-fit: fill;
      }
      .info {
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0 0.2rem;
        p {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
      .copy-btn {
        bottom: 0.8rem;
      }
    }
  }
}
.videos-list {
  .item.row {
    .cover {
      height: 14vw;
    }
    .mask {
      display: block;
      width: 28vw;
      height: 14vw;
      background: rgba(0, 0, 0, 40%);
      text-align: center;
      line-height: 14vw;
      font-size: 30px;
      color: #ffffff;
      position: absolute;
      z-index: 1;
      opacity: 0;
      transition: all 0.3s;
    }
  }
  .item:hover {
    .mask {
      opacity: 1;
    }
  }
}
.sider-tab {
  width: 10rem;
  height: 1rem;
  background: @normal-bg;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  border-radius: 0.8rem;
  position: relative;
  .tab-item {
    margin: 0;
    line-height: 1rem;
    width: 50%;
    text-align: center;
    z-index: 1;
    cursor: pointer;
    font-size: 0.38rem;
    &.active {
      color: #ffffff;
    }
  }
  &::after {
    content: "";
    position: absolute;
    width: 48%;
    height: 0.8rem;
    border-radius: 0.6rem;
    background: @primary-color;
    z-index: 0;
    left: 1%;
    top: 0.1rem;
    transition: left 0.3s;
  }
}
.sider-tab[data-tab="1"]::after {
  left: calc(51%);
}
.card-tag {
  margin-right: 10px;
}
.selector {
  text-align: center;
}
</style>
